module.exports = __webpack_public_path__ + "img/topicDomesticAppliances.e0d04da3.svg";